import React, { Component, Fragment } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import adminService from "../../Services/adminService";
import userService from "../../Services/userService";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Switch, FormGroup } from "@material-ui/core";
import Swal from "sweetalert2";

import {
  COMMENT_TYPES,
  COMMENT_LABEL_TYPES,
  USER_COMMENT_COLORS,
  INITIAL_NEW_ASSIGNMENT_TIME,
  INITIAL_SELECTED_FILTER_KEY_TAG,
  USER_ROLES
} from "../../global/userConstants";

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const GreenSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.common.white,
    "&$checked": {
      color: theme.palette.common.white
    },
    "&$checked + $track": {
      backgroundColor: "#3fff00"
    }
  },
  checked: {},
  track: {}
}))(Switch);

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

class CommentsComponent extends Component {
  state = {
    isPopupOpen: false,
    isPopupInEditMode: null,
    focusedItemWithComments: null,
    copyFocusedItemWithComments: null,
    newCommentData: "",
    price: "",
    commentTags: "",
    commentLabel: "",
    selectedFilterKeyTag: INITIAL_SELECTED_FILTER_KEY_TAG,
    // filterKeyTags: ["btax", "bquick", "courses"],
    selectedProduct: {},
    newAssignmentDate: null,
    newAssignmentTime: INITIAL_NEW_ASSIGNMENT_TIME,
    otherSalesmanTask: null,
    itemBeingEditted: [],
    popupProperties: {},
    newSaleRelatedMembers: []
  };

  componentDidMount() {
    this.setPopupData(true);
  }

  render() {
    const { state } = this;
    const role = localStorage.getItem("role");

    let { focusedItemWithComments } = state;
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={true}
          onClose={this.handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            <span style={{ color: `${state.popupProperties.titleColor}` }}>{state.popupProperties.title || "הערות לקוח"}</span>
          </DialogTitle>
          <DialogContent>
            <div className="popup-wrapper">
              <div className="mb-20">
                <FormControl className="ml-20 mr-20">
                  <InputLabel className="align-select-label">סינון תגובות לפי חברה</InputLabel>
                  <Select className="select-field" value={this.state.selectedFilterKeyTag} onChange={this.filterComments} displayEmpty>
                    <MenuItem value="all">ללא סינון</MenuItem>
                    {this.props.focusedViewTypes.map((item, viewTypeIndex) => {
                      return (
                        <MenuItem key={item + viewTypeIndex} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>

              <div className="mt-50 mb-20">
                <span className="primary-color">{state.popupProperties.titleNewItem}</span>
                {this.props.commentsType === COMMENT_TYPES.sales ? (
                  <div>
                    <Autocomplete
                      className="custom-autocomplete"
                      style={{ width: "90%" }}
                      options={this.state.products || []}
                      getOptionLabel={(option) => option.productType}
                      freeSolo={role === USER_ROLES.admin || role === USER_ROLES.salesManager ? true : false}
                      renderInput={(params) => <TextField {...params} label="מסמכים שקיימים במערכת" variant="outlined" />}
                      onInputChange={(event, newInputValue) => {
                        this.productChange({ target: { value: newInputValue } });
                      }}
                    />

                    <TextField
                      className="vertical-bottom"
                      onChange={(e) => {
                        this.newProductChanged(e, "price");
                      }}
                      disabled={role === USER_ROLES.admin || role === USER_ROLES.salesManager ? false : true}
                      value={this.state.selectedProduct.price || ""}
                    />
                    <TextField
                      onChange={(e) => {
                        this.newProductChanged(e, "productFreeTxt");
                      }}
                      label="הערות מכירה"
                      className="vertical-bottom increase-input-length"
                      value={this.state.selectedProduct.productFreeTxt || ""}
                    />
                    <Autocomplete
                      multiple
                      className="mt-32 mb-32"
                      id="sale-members-autocomplete"
                      options={this.props.btaxMembers || []}
                      getOptionLabel={(option) => option?.fullName}
                      value={this.state.newSaleRelatedMembers?.map?.((memberId) => {
                        return this.props.btaxMembers.find((btaxMember) => memberId === btaxMember._id);
                      })}
                      onChange={(e, selectedMembers) => {
                        const selectedMembersIds = selectedMembers.map((member) => member._id);
                        this.setState({ newSaleRelatedMembers: selectedMembersIds });
                      }}
                      renderInput={(params) => <TextField {...params} variant="standard" label="" placeholder="משתמשים הקשורים למכירה" />}
                    />
                  </div>
                ) : (
                  <Fragment>
                    {this.props.commentsType === COMMENT_TYPES.assignments ? (
                      <div className="mt-10 mb-20">
                        <div className="inline-block ml-10">
                          <input id="newAssignmentTime" type="time" value={this.state.newAssignmentTime} onChange={this.handleChange} />
                        </div>

                        {/* <Calendar onChange={this.handleChange} value={this.state.newAssignmentDate} /> */}
                        <input id="newAssignmentDate" type="date" value={this.state.newAssignmentDate} onChange={this.handleChange} />
                        <span className="nice-gray mr-10">(MM/DD/YYYY)</span>
                      </div>
                    ) : null}
                    <textarea id="newCommentData" onChange={this.handleChange} />
                  </Fragment>
                )}
                <div className="flex flex-row space-between">
                  <span className="primary-color">למי לייחס פעולה</span>
                  {this.props.focusedViewTypes.map((item, viewTypeIndex) => {
                    return (
                      <FormControlLabel
                        key={"dsdsd" + viewTypeIndex}
                        checked={this.state.commentTags.includes(item)}
                        className="align-checkbox-opts"
                        control={<Checkbox value={item} color="primary" />}
                        label={item}
                        onChange={(e) => {
                          this.handleChange(e, item);
                        }}
                      />
                    );
                  })}
                  {this.props.commentsType === COMMENT_TYPES.communications && (
                    <FormGroup style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "flex-end" }}>
                      <FormControlLabel
                        style={{ marginLeft: 0 }}
                        control={<GreenSwitch id="commentImportance" color="primary" onChange={this.toggleNewCommentImportance} />}
                        label="סמן כהערה חשובה ביותר"
                      />
                    </FormGroup>
                  )}
                </div>

                {this.props.isAllowedEditsInPopup && this.props.commentsType === COMMENT_TYPES.assignments ? (
                  <div>
                    <FormControl className="ml-20 mr-20">
                      <InputLabel className="align-select-label">שיוך משימה לאיש שיווק אחר</InputLabel>
                      <Select
                        className="select-field"
                        value={this.state.otherSalesmanTask}
                        onChange={this.handleOtherSalesmanChange}
                        displayEmpty
                      >
                        {this.props.salesAccs.map((item, index) => {
                          return (
                            <MenuItem key={item.email} value={item.email}>
                              {`${item.firstName} ${item.lastName}`}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                ) : null}

                <div className="mt-20">
                  <Button onClick={this.handleNewComment} color="primary" variant="contained" size="small">
                    הוסף
                  </Button>
                </div>
              </div>

              {focusedItemWithComments && focusedItemWithComments[0] ? (
                <TableContainer component={Paper}>
                  <Table aria-label="customized table">
                    <TableHead style={{ background: `${state.popupProperties.titleColor}` }}>
                      {state.popupProperties.tableHeaders}
                    </TableHead>
                    <TableBody>
                      <Fragment>{state.popupProperties.tableRows}</Fragment>
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div>עדיין אין תגובות...</div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} color="primary">
              סגור
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  handleClose = () => {
    this.setState({ popupProperties: {} }, () => {
      this.props.closePopUp();
    });
  };

  newProductChanged = (e, keyOfField) => {
    const selectedProduct = { ...this.state.selectedProduct };
    selectedProduct[keyOfField] = e.target.value;
    this.setState({ selectedProduct });
  };

  productChange = (e) => {
    const { value } = e.target;
    for (const product of this.state.products) {
      if (value === product.productType) {
        this.setState({ selectedProduct: product });
        return;
      }
    }
    this.setState({ selectedProduct: { productType: e.target.value } });
  };

  setPopupData = (isCompleteNewData) => {
    if (this.props.commentsType === COMMENT_TYPES.communications) {
      const newState = {
        copyFocusedItemWithComments: this.props.focusedItemWithComments.comments,
        focusedItemWithComments: this.props.focusedItemWithComments.comments
      };

      if (isCompleteNewData) {
        newState["itemBeingEditted"] = new Array(this.props.focusedItemWithComments.comments.length);
        newState["isPopupInEditMode"] = new Array(this.props.focusedItemWithComments.comments.length);
      }
      this.setState(newState, () => {
        const popupProperties = this.getPopupProperties();
        this.setState({ popupProperties });
      });
    } else if (this.props.commentsType === COMMENT_TYPES.sales) {
      const newState = {
        copyFocusedItemWithComments: this.props.focusedItemWithComments.sales,
        focusedItemWithComments: this.props.focusedItemWithComments.sales
      };

      if (isCompleteNewData) {
        newState["itemBeingEditted"] = new Array(this.props.focusedItemWithComments.sales.length);
        newState["isPopupInEditMode"] = new Array(this.props.focusedItemWithComments.sales.length);
        newState["products"] = adminService.getProductList();
      }
      this.setState(newState, () => {
        const popupProperties = this.getPopupProperties();
        this.setState({ popupProperties });
      });
    } else if (this.props.commentsType === COMMENT_TYPES.assignments) {
      const newState = {
        copyFocusedItemWithComments: this.props.userAssignments,
        focusedItemWithComments: this.props.userAssignments
      };

      if (isCompleteNewData) {
        newState["itemBeingEditted"] = new Array(this.props.userAssignments.length);
        newState["isPopupInEditMode"] = new Array(this.props.userAssignments.length);
      }
      this.setState(newState, () => {
        const popupProperties = this.getPopupProperties();
        this.setState({ popupProperties });
      });
    }
    // setTimeout(() => {
    //   this.setViewFromCard();
    // }, 200);
  };

  // setViewFromCard = () => {
  //   if (!this.props.focusedViewTypes) return;
  //   var focusedView = "all";
  //   this.handleChange({ target: { checked: true } }, focusedView);
  //   this.filterComments({ target: { value: focusedView } });
  // };

  getPopupProperties = () => {
    let allRows;
    const { isPopupInEditMode } = this.state;
    const tableRows = [];
    if (this.props.commentsType === COMMENT_TYPES.communications) {
      allRows = this.state.focusedItemWithComments;
      for (let index = 0; index < allRows.length; index++) {
        const row = allRows[index];
        tableRows.push(
          <StyledTableRow
            key={index}
            style={{
              ...(row.commentLabel && row.commentLabel === COMMENT_LABEL_TYPES.important
                ? { backgroundColor: USER_COMMENT_COLORS.important.bg }
                : {})
            }}
          >
            <StyledTableCell component="th" scope="row">
              <div className="blue-circle-background center">
                {adminService.translateAdminName(row.createdBy || "email", row.dateCreated)}
              </div>
            </StyledTableCell>
            <StyledTableCell align="right">
              {isPopupInEditMode && isPopupInEditMode[index] ? (
                <TextField
                  onChange={(e) => {
                    this.handleRowChange(e, index, "commentTxt");
                  }}
                  value={this.state.itemBeingEditted[index] ? this.state.itemBeingEditted[index].commentTxt : ""}
                ></TextField>
              ) : (
                <span>{row.commentTxt}</span>
              )}
            </StyledTableCell>
            <StyledTableCell style={{ minWidth: "110px" }} align="right">
              {moment(new Date(row.dateCreated).toString()).format("DD-MM-YYYY")}
              <br />
              {moment(new Date(row.dateCreated).toString()).format("HH:mm")}
            </StyledTableCell>
            <StyledTableCell className="tags-color" align="right">
              {row.commentTags.replace(/:/g, " / ")}
            </StyledTableCell>
            {this.props.isAllowedEditsInPopup && this.props.commentsType === COMMENT_TYPES.communications ? (
              <>
                <StyledTableCell align="center">
                  {isPopupInEditMode ? (
                    <GreenSwitch
                      id="commentImportance"
                      color="primary"
                      checked={row.commentLabel === COMMENT_LABEL_TYPES.important}
                      onChange={(e) => {
                        this.toggleExistingCommentImportance(row, index);
                      }}
                    />
                  ) : null}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {isPopupInEditMode && isPopupInEditMode[index] ? (
                    <Fragment>
                      <i
                        onClick={() => {
                          this.deleteRow(index);
                        }}
                        className="material-icons width40 pointer"
                      >
                        delete_outline
                      </i>
                      <i
                        onClick={() => {
                          this.toggleEditMode(index);
                        }}
                        className="material-icons width40 pointer"
                      >
                        cancel
                      </i>
                      <i
                        onClick={() => {
                          this.finishEditRow(index);
                        }}
                        className="material-icons width40 pointer"
                      >
                        check
                      </i>
                    </Fragment>
                  ) : (
                    <i
                      onClick={() => {
                        this.toggleEditMode(index);
                      }}
                      className="material-icons width40 pointer"
                    >
                      edit
                    </i>
                  )}
                </StyledTableCell>
              </>
            ) : null}
          </StyledTableRow>
        );
      }
      return {
        title: `התקשרויות אחרונות. משרד -  ${this.props.officeName}`,
        titleColor: "#95bd1c",
        titleNewItem: "הוספת התקשרות חדשה",
        tableHeaders: (
          <TableRow>
            <StyledTableCell>נכתב על ידי</StyledTableCell>
            <StyledTableCell align="right">תגובה</StyledTableCell>
            <StyledTableCell align="right">תאריך כתיבת התגובה</StyledTableCell>
            <StyledTableCell align="right">תגובה שייכת לחברה</StyledTableCell>
            {this.props.isAllowedEditsInPopup ? <StyledTableCell></StyledTableCell> : null}
            {this.props.isAllowedEditsInPopup ? <StyledTableCell></StyledTableCell> : null}
          </TableRow>
        ),
        tableRows: tableRows
      };
    }
    if (this.props.commentsType === COMMENT_TYPES.sales) {
      allRows = this.state.focusedItemWithComments ? this.state.focusedItemWithComments : [];
      for (let index = 0; index < allRows.length; index++) {
        const row = allRows[index];
        const membersRelatedToSale = this.props.btaxMembers.filter((member) => member?.relatedSales?.includes?.(row.identifier));
        tableRows.push(
          <StyledTableRow key={index}>
            <StyledTableCell component="th" scope="row">
              <div className="blue-circle-background center">
                {adminService.translateAdminName(row.createdBy || "email", row.dateCreated)}
              </div>
            </StyledTableCell>
            <StyledTableCell align="right">{row.productType}</StyledTableCell>
            <StyledTableCell align="right">{row.productFreeTxt}</StyledTableCell>
            <StyledTableCell style={{ minWidth: "110px" }} align="right">
              {moment(new Date(row.dateCreated).toString()).format("DD-MM-YYYY")}
              <br />
              {moment(new Date(row.dateCreated).toString()).format("HH:mm")}
            </StyledTableCell>
            <StyledTableCell align="right">{row.price}</StyledTableCell>
            <StyledTableCell className="tags-color" align="right">
              {row.commentTags}
            </StyledTableCell>
            <StyledTableCell className="tags-color" align="right">
              {membersRelatedToSale.map((member, idx) => (
                <Fragment key={member.identifier}>
                  <div className="green-circle-background center">{member.fullName}</div>
                  {membersRelatedToSale.length > 1 && idx !== membersRelatedToSale.length - 1 && <br />}
                </Fragment>
              ))}
            </StyledTableCell>
            {this.props.isAllowedEditsInPopup ? (
              <StyledTableCell align="center">
                {isPopupInEditMode && isPopupInEditMode[index] ? (
                  <Fragment>
                    <i
                      onClick={() => {
                        this.deleteRow(index);
                      }}
                      className="material-icons width40 pointer"
                    >
                      delete_outline
                    </i>
                    <i
                      onClick={() => {
                        this.toggleEditMode(index);
                      }}
                      className="material-icons width40 pointer"
                    >
                      cancel
                    </i>
                  </Fragment>
                ) : (
                  <Fragment>
                    {this.props.isAllowedEditsInPopup ? (
                      <i
                        onClick={() => {
                          this.toggleEditMode(index);
                        }}
                        className="material-icons width40 pointer"
                      >
                        edit
                      </i>
                    ) : null}
                  </Fragment>
                )}
              </StyledTableCell>
            ) : null}
          </StyledTableRow>
        );
      }

      return {
        title: `מכירות. משרד -  ${this.props.officeName}`,
        titleColor: "#29b0b1",
        titleNewItem: "הוספת רכישה חדשה",
        tableHeaders: (
          <TableRow>
            <StyledTableCell>נכתב על ידי</StyledTableCell>
            <StyledTableCell align="right">מוצר שנמכר</StyledTableCell>
            <StyledTableCell align="right">הערות</StyledTableCell>
            <StyledTableCell align="right">תאריך מכירה</StyledTableCell>
            <StyledTableCell align="right">סכום לפני מע"מ</StyledTableCell>
            <StyledTableCell align="right">תיוג חברה</StyledTableCell>
            <StyledTableCell align="right">משוייכת למשתמשים</StyledTableCell>
            {this.props.isAllowedEditsInPopup ? <StyledTableCell></StyledTableCell> : null}
          </TableRow>
        ),
        tableRows: tableRows
      };
    }

    if (this.props.commentsType === COMMENT_TYPES.assignments) {
      allRows = this.state.focusedItemWithComments;
      for (let index = 0; index < allRows.length; index++) {
        const row = allRows[index];
        const dueDate = userService.fixUtcFormat(row.dueDate);

        tableRows.push(
          <StyledTableRow key={index} style={row.isCompleted ? { backgroundColor: "#fff4b8" } : {}}>
            <StyledTableCell align="center">
              <Checkbox
                checked={!!row.isCompleted}
                onChange={() => this.toggleAssignmentCompleted(index)}
                disabled={isPopupInEditMode && isPopupInEditMode[index]}
                color="primary"
              />
            </StyledTableCell>
            <StyledTableCell className="min-width-152" align="right">
              {isPopupInEditMode && isPopupInEditMode[index] ? (
                <input
                  onChange={(e) => {
                    this.handleRowChange(e, index, "dueDate");
                  }}
                  value={
                    this.state.itemBeingEditted[index]
                      ? moment(userService.fixUtcFormat(this.state.itemBeingEditted[index].dueDate)).format("YYYY-MM-DDTHH:mm")
                      : new Date().toLocalString()
                  }
                  type="datetime-local"
                />
              ) : (
                <Fragment>
                  {moment(dueDate).format("DD-MM-YYYY")}
                  <br />
                  {moment(dueDate).format("HH:mm")}
                </Fragment>
              )}
            </StyledTableCell>
            <StyledTableCell align="right">
              <div className="blue-circle-background center">
                {adminService.translateAdminName(row.createdBy || "email", row.dateCreated)}
              </div>
            </StyledTableCell>
            <StyledTableCell align="right">
              {isPopupInEditMode && isPopupInEditMode[index] ? (
                <TextField
                  onChange={(e) => {
                    this.handleRowChange(e, index, "assignmentTxt");
                  }}
                  value={this.state.itemBeingEditted[index] ? this.state.itemBeingEditted[index].assignmentTxt : ""}
                ></TextField>
              ) : (
                <span style={row.isCompleted ? { textDecoration: "line-through", fontWeight: "bold" } : {}}>{row.assignmentTxt}</span>
              )}
            </StyledTableCell>

            <StyledTableCell className="tags-color" align="right">
              {row.assignmentTags.replace(/:/g, " / ")}
            </StyledTableCell>
            <StyledTableCell className="min-width-152" align="center">
              {isPopupInEditMode && isPopupInEditMode[index] ? (
                <Fragment>
                  <i
                    onClick={() => {
                      this.deleteRow(index);
                    }}
                    className="material-icons width40 pointer"
                  >
                    delete_outline
                  </i>
                  <i
                    onClick={() => {
                      this.toggleEditMode(index);
                    }}
                    className="material-icons width40 pointer"
                  >
                    cancel
                  </i>
                  <i
                    onClick={() => {
                      this.finishEditRow(index);
                    }}
                    className="material-icons width40 pointer"
                  >
                    check
                  </i>
                </Fragment>
              ) : (
                <i
                  onClick={() => {
                    this.toggleEditMode(index);
                  }}
                  className="material-icons width40 pointer"
                >
                  edit
                </i>
              )}
            </StyledTableCell>
          </StyledTableRow>
        );
      }
      return {
        title: `משימות פתוחות. משרד -  ${this.props.officeName}`,
        titleColor: "#ed008c",
        titleNewItem: "הוספת משימה חדשה",
        tableHeaders: (
          <TableRow>
            <StyledTableCell align="center">בוצע</StyledTableCell>
            <StyledTableCell align="right">תאריך יעד</StyledTableCell>
            <StyledTableCell align="right">נכתב על ידי</StyledTableCell>
            <StyledTableCell align="right">משימה</StyledTableCell>
            <StyledTableCell align="right">משימה שייכת לחברה</StyledTableCell>
            <StyledTableCell align="right"></StyledTableCell>
          </TableRow>
        ),
        tableRows: tableRows
      };
    }

    return {};
  };

  toggleEditMode = (index) => {
    const isPopupInEditMode = [...this.state.isPopupInEditMode];
    const itemBeingEditted = [...this.state.itemBeingEditted];

    isPopupInEditMode[index] = !isPopupInEditMode[index];
    itemBeingEditted[index] = { ...this.state.focusedItemWithComments[index] };

    this.setState({ isPopupInEditMode, itemBeingEditted }, this.setPopupData);
  };

  filterComments = (e) => {
    const selectedFilterKeyTag = e.target.value;
    // selectedFilterKeyTag

    if (selectedFilterKeyTag === "all") {
      this.setState({ focusedItemWithComments: [...this.state.copyFocusedItemWithComments], selectedFilterKeyTag }, () => {
        this.setState({ popupProperties: this.getPopupProperties() });
      });
    } else {
      const tagType = this.props.commentsType === COMMENT_TYPES.assignments ? "assignmentTags" : "commentTags";
      let getComments = this.state.copyFocusedItemWithComments.filter((item) => item[tagType].includes(selectedFilterKeyTag));
      this.setState({ focusedItemWithComments: getComments, selectedFilterKeyTag }, () => {
        this.setState({ popupProperties: this.getPopupProperties() });
      });
    }
  };

  handleOtherSalesmanChange = (e) => {
    this.setState({ otherSalesmanTask: e.target.value });
  };

  handleRowChange = (e, index, keyForChange) => {
    var itemBeingEditted = [...this.state.itemBeingEditted];
    itemBeingEditted[index][keyForChange] = e.target.value;
    this.setState({ itemBeingEditted }, this.setPopupData);
  };

  toggleAssignmentCompleted = (index) => {
    if (!this.props.toggleAssignmentCompleted) return;
    this.props.toggleAssignmentCompleted(this.state.focusedItemWithComments[index], () => {
      this.setPopupData(true);
    });
  };

  handleRowValueChange(index, key, value) {
    const itemBeingEditted = { ...this.state.focusedItemWithComments[index], [key]: value };
    this.props.handleEditCommunicationsRowValue(itemBeingEditted, index, () => {
      this.setPopupData(true);
    });
  }

  deleteRow = (index) => {
    this.props.deleteRow(this.state.itemBeingEditted[index]._id || this.state.itemBeingEditted[index].identifier, index, () => {
      this.setPopupData(true);
    });
  };

  finishEditRow = (index) => {
    this.props.finishEditRow(this.state.itemBeingEditted[index], index, () => {
      this.toggleEditMode(index);
    });
  };

  handleChange = (e, commentTag) => {
    if (commentTag === "all") return;
    let key;
    let value;
    if (commentTag) {
      key = "commentTags";
      if (e.target.checked) {
        if (this.state.commentTags) {
          if (!this.state.commentTags.includes(commentTag)) value = this.state.commentTags + ":" + commentTag;
          else return;
        } else value = commentTag;
      } else {
        value = this.state.commentTags
          .split(":")
          .filter((item) => item !== commentTag)
          .join(":");
      }
    } else {
      key = e.target.id;
      value = e.target.value;
    }
    this.setState({
      [key]: value
    });
  };

  checkBeforeAddNewSaleComment = async ({ newSaleRelatedMembers }) => {
    //func to validate new sale comment before adding it
    let cancelAddNewSaleComment = false;
    if (!newSaleRelatedMembers?.length) {
      //confirm add sale without related members
      const { isDismissed } = await Swal.fire({
        html: "אף משתמש לא שוייך למכירה, להמשיך?",
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "המשך",
        cancelButtonText: "בטל"
      });
      if (isDismissed) cancelAddNewSaleComment = true;
    }
    return { cancelAddNewSaleComment };
  };

  handleNewComment = async () => {
    if (this.props.commentsType === COMMENT_TYPES.sales) {
      //checking a new sale comment before adding it
      const { newSaleRelatedMembers } = this.state;
      const { cancelAddNewSaleComment } = await this.checkBeforeAddNewSaleComment({ newSaleRelatedMembers });
      if (cancelAddNewSaleComment) return;
    }

    this.props.handleNewComment(
      this.props.commentsType,
      this.state.selectedProduct,
      this.state.newCommentData,
      this.state.commentTags,
      this.state.commentLabel,
      this.state.newAssignmentDate,
      this.state.newAssignmentTime,
      this.state.otherSalesmanTask,
      this.state.newSaleRelatedMembers,
      () => {
        this.setPopupData();
        if (this.props.commentsType === COMMENT_TYPES.sales) {
          this.setState({ newSaleRelatedMembers: [], selectedProduct: { ...this.state.selectedProduct, saleRelatedMembers: [] } });
        }
      }
    );
  };

  toggleNewCommentImportance = () => {
    const newLabel =
      this.state.commentLabel === COMMENT_LABEL_TYPES.important ? COMMENT_LABEL_TYPES.noLabel : COMMENT_LABEL_TYPES.important;
    this.setState({ commentLabel: newLabel });
  };

  toggleExistingCommentImportance = async (comment, index) => {
    const { identifier, dateCreated, commentLabel } = comment;
    const newLabel = commentLabel === COMMENT_LABEL_TYPES.important ? COMMENT_LABEL_TYPES.noLabel : COMMENT_LABEL_TYPES.important;
    const toggleRes = await adminService.adminUpdateUserCommentLabel(identifier, dateCreated, newLabel);
    if (toggleRes.success) {
      this.handleRowValueChange(index, "commentLabel", newLabel);
    } else {
      Swal.fire("התרחשה תקלה, שינוי חשיבות התגובה לא בוצע", "", "error");
    }
  };
}

export default CommentsComponent;
